import { useGqlQuery } from '@API/useAvQuery';
import { QueryKey } from '@fabric-ui/utils';
import { gql } from 'graphql-request';
import { useAvContext } from '../context/AvContextProvider';
import { AppDto } from '../context/types';
import { getAccountTokenFromLS } from '../utils/auth.utils';

export const GET_ALL_APPS = gql`
  query findAllApps {
    findAllApps {
      id
      name
      config
    }
  }
`;

export const useAllApps = () => {
  const { accountId } = useAvContext();
  return useGqlQuery<AppDto[]>({
    queryKey: [QueryKey.FindAllApps],
    query: GET_ALL_APPS,
    enabled: !!accountId && !!getAccountTokenFromLS(accountId),
  });
};
